import { routeNames } from '@/router/routeNames'

import type { RouteRecordRaw } from 'vue-router'

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: routeNames.Dashboard,
    meta: { title: 'common.route.dashboard' },
    component: () => import('@/views/DashboardView.vue'),
  },
  {
    path: '/dashboard/logs',
    name: routeNames.Logs,
    meta: { title: 'common.route.logs' },
    component: () => import('@/views/LogsView.vue'),
  },
  {
    path: '/dashboard/statistics',
    name: routeNames.Statistics,
    meta: { title: 'common.route.statistics' },
    component: () => import('@/views/StatisticsView.vue'),
  },
  {
    path: '/dashboard/profile',
    name: routeNames.Profile,
    meta: { title: 'common.route.profile' },
    component: () => import('@/views/ProfileView.vue'),
  },
  {
    path: '/dashboard/configuration',
    name: routeNames.Flows,
    meta: { title: 'common.route.flows' },
    component: () => import('@/views/FlowsView.vue'),
  },
  {
    path: '/dashboard/criteria',
    name: routeNames.Criteria,
    meta: { title: 'common.route.criteria' },
    component: () => import('@/views/CriteriaView.vue'),
  },
  {
    path: '/dashboard/configuration/new',
    name: routeNames.ConfigurationNew,
    meta: { title: 'common.route.createConfiguration' },
    component: () => import('@/views/ConfigurationCreateView.vue'),
  },
  {
    path: '/dashboard/files/:id?',
    name: routeNames.Files,
    meta: { title: 'common.route.files' },
    component: () => import('@/views/FilesView.vue'),
  },
  {
    path: '/dashboard/roles',
    name: routeNames.Roles,
    meta: { title: 'common.route.roles' },
    component: () => import('@/views/RolesView.vue'),
  },
  {
    path: '/dashboard/users',
    name: routeNames.Users,
    meta: { title: 'common.route.users' },
    component: () => import('@/views/UsersView.vue'),
  },
  {
    path: '/dashboard/finished-configurations',
    name: routeNames.ConfigurationsFinished,
    meta: { title: 'common.route.configurationFinished' },
    component: () => import('@/views/FinishedConfigurationsView.vue'),
  },
  {
    path: '/dashboard/finished-configuration/:finishedConfigurationUuid',
    name: routeNames.ConfigurationFinished,
    meta: { title: 'common.route.configurationsFinished' },
    component: () => import('@/views/FinishedConfigurationView.vue'),
    props: true,
  },
]
